"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lazy_1 = __importDefault(require("react-player/lazy"));
var axios_1 = __importDefault(require("axios"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var styled_components_1 = __importDefault(require("styled-components"));
var once_1 = __importDefault(require("lodash/once"));
var react_2 = require("react");
var PlayerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: 56.25%;\n  box-shadow: ", ";\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"], ["\n  position: relative;\n  padding-top: 56.25%;\n  box-shadow: ", ";\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"])), function (_a) {
    var boxShadow = _a.boxShadow;
    return boxShadow;
});
var OverlayContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url(", ");\n  background-size: cover;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  @keyframes heartbeat {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  .play-icon {\n    display: table;\n    pointer-events: none;\n    animation: 2s infinite heartbeat;\n    border-style: solid;\n    border-width: ", ";\n    border-color: ", ";\n    margin-left: 7px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url(", ");\n  background-size: cover;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  @keyframes heartbeat {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.2);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  .play-icon {\n    display: table;\n    pointer-events: none;\n    animation: 2s infinite heartbeat;\n    border-style: solid;\n    border-width: ",
    ";\n    border-color: ",
    ";\n    margin-left: 7px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])), function (_a) {
    var poster = _a.poster;
    return poster;
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return playIconSize + "px 0 " + playIconSize + "px " + playIconSize * 1.7 + "px !important";
}, function (_a) {
    var playIconColor = _a.playIconColor;
    return "transparent transparent transparent " + playIconColor + " !important";
});
var sendEvent = function (eventName) {
    react_gtm_module_1.default.dataLayer({
        dataLayer: { event: eventName }
    });
};
var sendEvent10Percent = function () {
    sendEvent('VIDEO_Played10');
};
var sendEvent10PercentOnce = once_1.default(sendEvent10Percent);
var sendEvent20Percent = function () {
    sendEvent('VIDEO_Played20');
};
var sendEvent20PercentOnce = once_1.default(sendEvent20Percent);
var sendEvent30Percent = function () {
    sendEvent('VIDEO_Played30');
};
var sendEvent30PercentOnce = once_1.default(sendEvent30Percent);
var sendEvent40Percent = function () {
    sendEvent('VIDEO_Played40');
};
var sendEvent40PercentOnce = once_1.default(sendEvent40Percent);
var sendEvent50Percent = function () {
    sendEvent('VIDEO_Played50');
};
var sendEvent50PercentOnce = once_1.default(sendEvent50Percent);
var sendEvent60Percent = function () {
    sendEvent('VIDEO_Played60');
};
var sendEvent60PercentOnce = once_1.default(sendEvent60Percent);
var sendEvent70Percent = function () {
    sendEvent('VIDEO_Played70');
};
var sendEvent70PercentOnce = once_1.default(sendEvent70Percent);
var sendEvent80Percent = function () {
    sendEvent('VIDEO_Played80');
};
var sendEvent80PercentOnce = once_1.default(sendEvent80Percent);
var sendEvent90Percent = function () {
    sendEvent('VIDEO_Played90');
};
var sendEvent90PercentOnce = once_1.default(sendEvent90Percent);
var onProgress = function (state) {
    if (state.played > 0.1) {
        sendEvent10PercentOnce();
    }
    if (state.played > 0.2) {
        sendEvent20PercentOnce();
    }
    if (state.played > 0.3) {
        sendEvent30PercentOnce();
    }
    if (state.played > 0.4) {
        sendEvent40PercentOnce();
    }
    if (state.played > 0.5) {
        sendEvent50PercentOnce();
    }
    if (state.played > 0.6) {
        sendEvent60PercentOnce();
    }
    if (state.played > 0.7) {
        sendEvent70PercentOnce();
    }
    if (state.played > 0.8) {
        sendEvent80PercentOnce();
    }
    if (state.played > 0.9) {
        sendEvent90PercentOnce();
    }
};
var VideoPlayer = function (_a) {
    var url = _a.url, _b = _a.controls, controls = _b === void 0 ? true : _b, poster = _a.poster, _c = _a.loop, loop = _c === void 0 ? false : _c, _d = _a.autoplay, autoplay = _d === void 0 ? false : _d, _e = _a.muted, muted = _e === void 0 ? false : _e, _f = _a.volume, volume = _f === void 0 ? 0.8 : _f, _g = _a.playsinline, playsinline = _g === void 0 ? true : _g, _h = _a.color, color = _h === void 0 ? 'ffc000' : _h, _j = _a.title, title = _j === void 0 ? false : _j, _k = _a.boxShadow, boxShadow = _k === void 0 ? '10px 10px 30px 0px rgba(0, 0, 0, 0.25)' : _k, _l = _a.playIconColor, playIconColor = _l === void 0 ? '#fff' : _l, _m = _a.playIconPulsing, playIconPulsing = _m === void 0 ? true : _m, _o = _a.playIconSize, playIconSize = _o === void 0 ? 16 : _o;
    var playerConfig = {
        autoplay: autoplay,
        muted: muted,
        color: color.replace('#', ''),
        title: title,
        dnt: true,
        preload: true
    };
    var _p = react_2.useState(false), playing = _p[0], setPlaying = _p[1];
    var _q = react_2.useState(poster), thumbnail = _q[0], setThumbnail = _q[1];
    var _r = react_2.useState(true), showOverlay = _r[0], setShowOverlay = _r[1];
    var player = react_2.useRef(null);
    react_2.useEffect(function () {
        // Get thumbnail from vimeo if poster not set
        if (!poster && (url === null || url === void 0 ? void 0 : url.includes('vimeo'))) {
            axios_1.default.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (res) {
                var _a;
                setThumbnail((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.thumbnail_url);
            });
        }
    }, []);
    var onStartHandler = function () {
        setShowOverlay(false);
        sendEvent('VIDEO_Started');
    };
    return (react_1.default.createElement(PlayerWrapper, { boxShadow: boxShadow },
        react_1.default.createElement(lazy_1.default, { className: "react-player", ref: player, url: url, controls: controls, loop: loop, muted: muted, volume: volume, playing: playing, playsinline: playsinline, width: '100%', height: '100%', onBuffer: function () { return setShowOverlay(false); }, onStart: onStartHandler, onEnded: function () { return sendEvent('VIDEO_Ended'); }, onProgress: onProgress, config: {
                youtube: {
                    playerVars: playerConfig
                },
                vimeo: {
                    playerOptions: playerConfig
                }
            } }),
        showOverlay && (react_1.default.createElement(OverlayContainer, { onClick: function () { return setPlaying(true); }, poster: thumbnail, playIconPulsing: playIconPulsing, playIconSize: playIconSize, playIconColor: playIconColor },
            react_1.default.createElement("div", { className: "play-icon" })))));
};
exports.default = VideoPlayer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=VideoPlayer.js.map